import React from "react";

const WorkProcessFive = () => {
  return (
    <>
      {/*==================== Work Process Three start ====================*/}
      <div className='work-process-area pd-top-120 pd-bottom-120'>
        <div className='container'>
          <div className='section-title text-center pb-5'>
            <h6 className='color-base mb-3 bg-none'>Work Process</h6>
            <h2 className='title'>Defend Your Business Digital World</h2>
          </div>
          <div className='row'>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-4 text-center'>
                <h5>Secure Net</h5>
                <div className='thumb'>
                  <img src='assets/img/home-6/13.png' alt='img' />
                </div>
                <span className='count'>01</span>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-4 text-center'>
                <h5>Tech Shield</h5>
                <div className='thumb'>
                  <img src='assets/img/home-6/14.png' alt='img' />
                </div>
                <span className='count'>02</span>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-4 text-center'>
                <h5>Byte Busters</h5>
                <div className='thumb'>
                  <img src='assets/img/home-6/15.png' alt='img' />
                </div>
                <span className='count'>03</span>
              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='single-work-process-inner-4 text-center'>
                <h5>Data Armor</h5>
                <div className='thumb'>
                  <img src='assets/img/home-6/16.png' alt='img' />
                </div>
                <span className='count'>04</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== Work Process Three end ====================*/}
    </>
  );
};

export default WorkProcessFive;
